import dayjs, { Dayjs } from 'dayjs';
import { SourceFilter, StatusFilter } from './date-range-picker.types';

export interface PresetRange {
  /** Transloco key under `dateRangePicker.presets`. Resolved at render time so the
   * popover follows the active locale — the labels used to be hardcoded French. */
  labelKey: string;
  range: () => [Dayjs, Dayjs];
}

export const PRESET_RANGES: PresetRange[] = [
  { labelKey: 'last15min', range: () => [dayjs().subtract(15, 'minute'), dayjs()] },
  { labelKey: 'last30min', range: () => [dayjs().subtract(30, 'minute'), dayjs()] },
  { labelKey: 'lastHour', range: () => [dayjs().subtract(1, 'hour'), dayjs()] },
  { labelKey: 'last6h', range: () => [dayjs().subtract(6, 'hour'), dayjs()] },
  { labelKey: 'last12h', range: () => [dayjs().subtract(12, 'hour'), dayjs()] },
  { labelKey: 'today', range: () => [dayjs().startOf('day'), dayjs()] },
  {
    labelKey: 'yesterday',
    range: () => [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
  },
  { labelKey: 'last7d', range: () => [dayjs().subtract(6, 'day').startOf('day'), dayjs()] },
  { labelKey: 'last30d', range: () => [dayjs().subtract(29, 'day').startOf('day'), dayjs()] },
];

/** `labelKey` resolves under `dateRangePicker.status`. */
export const STATUS_OPTIONS = [
  { labelKey: 'all', value: StatusFilter.BOTH },
  { labelKey: 'onlineOnly', value: StatusFilter.ONLINE },
  { labelKey: 'offlineOnly', value: StatusFilter.OFFLINE },
];

/** Source labels are protocol names — same in every locale, so no key indirection. */
export const SOURCES_OPTIONS = [
  { label: 'ALL', value: SourceFilter.ALL },
  { label: '4G Embarquée', value: SourceFilter.EMBARQUE },
  { label: '4G Debarquée', value: SourceFilter.DEBARQUE },
  { label: 'BLE', value: SourceFilter.BLE },
  { label: 'Lora', value: SourceFilter.LORA },
];
